// extracted by mini-css-extract-plugin
export default {"imgdiv":"cfb7f85209 f1d9ba420d","img":"_13a1e862c5 c1cd4926e7"};